import * as React from 'react';
import { Currency } from '../../Api';

interface Props {
  handleSubmit: () => any;
  disabled: boolean;
  icon: JSX.Element | null;
  buttonText: string;
  total: number;
  currency: Currency;
}

interface State {}

class SubmitOrder extends React.Component<Props, State> {
  public render(): JSX.Element {
    const { handleSubmit, icon, buttonText } = this.props;

    return (
      <button
        className="checkout__submit-order fd-button fd-button--big fd-button--secondary flex flex-align-center flex-justify-center block-center hidden-sm hidden-xs"
        disabled={this.props.disabled}
        onClick={handleSubmit}
      >
        <span className="flex flex-align-center flex-justify-center">
          {icon}
          <p className="clear-margins primary">{buttonText}</p>
        </span>
      </button>
    );
  }
}

export default SubmitOrder;
